import { Component } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
	selector: 'app-generic-confirmation-dialog',
	templateUrl: './generic-confirmation-dialog.component.html',
	styleUrls: ['./generic-confirmation-dialog.component.scss']
})
export class GenericConfirmationDialogComponent {

	innerHTML! : string;
	negativeButtonCaption! : string;
	positiveButtonCaption! : string;
	positiveButtonColor : ThemePalette;
	center! : boolean;

	// Prefiero hacer una función así en todos los díalogos que me defina en los argumentos lo que tengo que pasarle
	// antes que tener que pasarle un data y tener que buscar a mano qué variables necesita cada modal cada vez que lo voy a usar
	set(innerHtml:string, negativeButtonCaption:string, positiveButtonCaption:string, positiveButtonColor:ThemePalette, center=true) {
		this.innerHTML = innerHtml;
		this.negativeButtonCaption = negativeButtonCaption;
		this.positiveButtonCaption = positiveButtonCaption;
		this.positiveButtonColor = positiveButtonColor;
		this.center = center;
	}
}
